<template>
	<div id="map-radius">
		<GmapMap
			ref="map"
			:options="mapOptions"
			:center="{ lat: 53.4723679, lng: -2.363546 }"
			:zoom="6"
			@center_changed="updateViewportCenter"
		>
			<!-- Ranges -->
			<GmapCircle
				v-for="(range, index) in ranges"
				:key="`range_${index}`"
				:center="viewportCenter"
				:radius="distancePerDelta(index + 1)"
				:draggable="false"
				:editable="false"
				:options="rangeCircleOptions"
			/>
			<!-- Range markers -->
			<GmapMarker
				v-for="(range, index) in ranges"
				:key="`range-marker_${index}`"
				:icon="range.icon"
				:position="rangeMarkerPos(index + 1)"
			/>
			<!-- Centre marker -->
			<GmapMarker :position="viewportCenter" :icon="customMarker"/>
		</GmapMap>
	</div>
</template>

<script>
import { gmapApi } from "vue2-google-maps"
import mapTheme from './map-theme'

export default {
	name: "FlytRanges",

	data() {
		return {
			// Origin marker
			customMarker: {
				url: require("@/assets/icons_helipad-pin--public.svg"),
				size: { width: 32, height: 48 },
				scaledSize: { width: 32, height: 48 },
			},
			// Google map settings
			mapOptions: {
				backgroundColor: '#f1f1f1',
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				disableDefaultUi: false,
				styles: mapTheme,
				scrollwheel: false
			},
			// Initialise viewport
			viewportCenter: { lat: 53.4723679, lng: -2.363546 },
			// Distance per timestep (30m)
			rangePerDelta: 112654,
			// Range marker icons and positions
			ranges: [
				{
					icon: require(`@/components/ranges/markers/30m.svg`),
					position: null
				},
				{
					icon: require(`@/components/ranges/markers/1h.svg`),
					position: null
				},
				{
					icon: require(`@/components/ranges/markers/1h30m.svg`),
					position: null
				},
				{
					icon: require(`@/components/ranges/markers/2h.svg`),
					position: null
				}
			],
			// Display settings for ranges
			rangeCircleOptions: {
				strokeColor: "#A78357",
				strokeOpacity: 1,
				strokeWeight: 1,
				fillColor: "#0000FF",
				fillOpacity: 0
			}
		}
	},

	computed: {
		gmapApi,
	},

	methods: {
		/**
		 * Set viewport lat/lng based on map centre
		 */
		updateViewportCenter() {
			this.viewportCenter.lat = this.$refs.map.$mapObject.center.lat()
			this.viewportCenter.lng = this.$refs.map.$mapObject.center.lng()
		},

		/**
		 * Returns a position, 45 degrees from the viewport centre,
		 * at a distance of: range per delta x multiplier 
		 */
		rangeMarkerPos(deltaMultiplier) {
			if (!this.gmapApi) return
			let distanceFromCentre = this.distancePerDelta(deltaMultiplier)
			let centre = new this.gmapApi.maps.LatLng(this.viewportCenter)
			return this.gmapApi.maps.geometry.spherical.computeOffset(centre, distanceFromCentre, 45)
		},

		/**
		 * Returns a multiple of the distance per timestep
		 */
		distancePerDelta(deltaMultiplier) {
			return this.rangePerDelta * deltaMultiplier
		}
	},

	mounted() {
		// Add the range markers once libraries have loaded
		this.$gmapApiPromiseLazy().then(() => {
			this.ranges.forEach((range, index) => range.position = this.rangeMarkerPos(index))
		})
	}
}
</script>

<style lang="scss" scoped>
#map-radius {
	height: calc(85vh - #{$navbar-height});
	margin-top: var(--section-padding);
}

/deep/ .vue-map-container {
	height: 100%;
}

/deep/ .vue-map {
	height: 100%;
}
</style>
